import { toast } from "react-toastify";
import { BACKEND_SERVER_URL } from "../../../http/http-config";
import swal from "sweetalert";
import axios from "axios";
import { Spinner } from "react-bootstrap";

export async function bulkOperations(action, records, apiName, moduleName, setItemsLoading, loadItems) {
    let ids = records.filter(record => record.inputchecked).map(record => record.sn);
    console.log(action, records, apiName, moduleName, setItemsLoading, loadItems)
    if (ids.length <= 0) {
        toast.error(`Please select atleast one item`);
        return;
    }
    const postData = { ids: ids };
    switch (action) {
        case "delete":
            swal({
                title: "Are you sure?",
                text: `Once deleted, you will not be able to recover these ${moduleName}`,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((yes) => {
                if (yes) {
                    axios.post(BACKEND_SERVER_URL + apiName, postData).then((response) => {
                        if (response) {
                            toast.success(response.data.message);
                            setItemsLoading(!loadItems)
                        }
                    }).catch((error) => {
                        toast.error(error.message);
                    });

                }
            })
            break;
        case "activate":
            swal({
                title: "Are you sure?",
                text: `Do you really want to activate these ${moduleName}`,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((yes) => {
                if (yes) {
                    axios.post(BACKEND_SERVER_URL + apiName, postData).then((response) => {
                        if (response) {
                            toast.success(response.data.message);
                            setItemsLoading(!loadItems)

                        }
                    }).catch((error) => {
                        toast.error(error.message);
                    });

                }
            })
            break;
        case "InActivate":
            swal({
                title: "Are you sure?",
                text: `Do you really want to inactivate these ${moduleName}`,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((yes) => {
                if (yes) {
                    axios.post(BACKEND_SERVER_URL + apiName, postData).then((response) => {
                        if (response) {
                            toast.success(response.data.message);
                            setItemsLoading(!loadItems)

                        }
                    }).catch((error) => {
                        toast.error(error.message);
                    });

                }
            })
            break;
    }
}

export async function deleteItem(id, itemName, apiName, setItemsLoading, loadItems, method = 'delete') {
    swal({
        title: "Are you sure?",
        text: `Once deleted, you will not be able to recover this ${itemName}`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete) {
            axios({
                method: method, // dynamic method
                url: BACKEND_SERVER_URL + apiName + id,
            }).then((res) => {
                if (res) {
                    swal(`Poof! Your ${itemName} has been deleted!`, {
                        icon: "success",
                    });
                    setItemsLoading(!loadItems);
                }
            }).catch(error => {
                console.log(error.response.data)
                toast.error(error.response.data.message)
            })
        }
    })
}
export async function handleChecked(sn, setChecked, checked) {
    let temp = checked.map((data) => {
        if (sn === data.sn) {
            return { ...data, inputchecked: !data.inputchecked };
        }
        return data;
    });
    setChecked(temp);
}

export async function handleCheckedAll(value, checked, setChecked, setUnChecked) {
    let temp = checked.map((data) => {
        return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!value);
}
export async function handleSearch(value, setChecked, dataArray, searchingProperty) {
    const filteredItems = dataArray?.filter(
        item => item?.[searchingProperty]?.toLowerCase().includes(value?.toLowerCase())
    );
    console.log(filteredItems)
    setChecked(filteredItems)
}
export function showTableResponse(totalItems, checked) {
    if (totalItems && totalItems.length < 1) {
        return <Spinner animation="grow" variant="info" />
    } else if (totalItems.length > 0 && checked.length < 1) {
        return <h3>No Data Found</h3>
    }
}

export async function checkExistingItem(tableName, columnName, itemNameValue) {
    try {
        let response = await axios.post(BACKEND_SERVER_URL + '/check-duplicate-item', { tableName, columnName, itemNameValue })
        if (response.data.isExists) {
            toast.warn("Item Already Exists")
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.log(error)
    }
}

export async function getQuizSubjectsForDropdowns() {
    try {
        const res = await axios.get(BACKEND_SERVER_URL + '/getSubjectForSectionsDropdown');
        let subjects = res.data.subjects;
        return subjects;
    } catch (error) {
        console.log(error)
        toast.error(error.response.data.message)
    }
}
export async function getQuizSectionsForDropdowns() {
    try {
        const res = await axios.get(BACKEND_SERVER_URL + '/getSectionsForDropdown');
        let sections = res.data.sections;
        return sections;
    } catch (error) {
        console.log(error)
        toast.error(error.response.data.message)
    }
}

export async function getTotalQuizQuestionCount() {
    return (await axios.get(BACKEND_SERVER_URL + '/getTotalQuizQuestionCount')).data.questionCount
}
export async function getCUETQuestionCount(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/cuet/question-count?${params}`)).data.questionCount
}
export async function getNEETQuestionCount(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/neet/question-count?${params}`)).data.questionCount
}
export async function getQuizQuestions(questionOffset) {
    return (await axios.get(BACKEND_SERVER_URL + '/getQuizQuestions/' + questionOffset)).data.questions
}
export async function fetchQuestionByQNo(customQuestionNumber) {
    return (await axios.get(BACKEND_SERVER_URL + '/fetchQuestionByQNo/' + customQuestionNumber)).data.question
}
export async function getCUETQuestions(questionOffset, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/cuet/questions/${questionOffset}?${params}`)).data.questions
}
export async function getUGCQuestions(questionOffset, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/ugc/questions/${questionOffset}?${params}`)).data.questions
}
export async function getUGCQuestionCount(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/ugc/question-count?${params}`)).data.questionCount
}
export async function getNEETQuestions(questionOffset, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return (await axios.get(BACKEND_SERVER_URL + `/neet/questions/${questionOffset}?${params}`)).data.questions
}
export function sortInAlphabeticalOrder(array, title) {
    array.sort((a, b) => {
        const orderA = Number(a.DisplayOrder) || 0;
        const orderB = Number(b.DisplayOrder) || 0;
        if (orderA > 0 && orderB === 0) return -1;
        if (orderA === 0 && orderB > 0) return 1;
        if (orderA > 0 && orderB > 0 && orderA !== orderB) {
            return orderA - orderB;
        }

        // Convert subjects to lowercase to ensure case-insensitive sorting
        const titleA = (a[title] && typeof a[title] === 'string') ? a[title].toLowerCase() : '';
        const titleB = (b[title] && typeof b[title] === 'string') ? b[title].toLowerCase() : '';
        // Compare subjects
        if (titleA < titleB) {
            return -1;
        }
        if (titleA > titleB) {
            return 1;
        }
        return 0; // subjects are equal
    });
    return array;
}

export const multiSortTopics = (array) => {
    const getExamTypeLabel = (id) => {
        if (id === "COMBINED") return "COMBINED TESTS";
        if (id === "SUBJECT SPECIFIC") return "Academic Subjects";
        if (id === "GENERAL APTITUDE") return "Teaching & Research Aptitude";
        return id || '';
    };

    return array.sort((a, b) => {
        const examTypeA = getExamTypeLabel(a.ExamType).toLowerCase();
        const examTypeB = getExamTypeLabel(b.ExamType).toLowerCase();
        if (examTypeA < examTypeB) return -1;
        if (examTypeA > examTypeB) return 1;

        const subjectOrderA = Number(a.SubjectOrder) || 0;
        const subjectOrderB = Number(b.SubjectOrder) || 0;
        if (subjectOrderA > 0 && subjectOrderB === 0) return -1;
        if (subjectOrderA === 0 && subjectOrderB > 0) return 1;
        if (subjectOrderA > 0 && subjectOrderB > 0 && subjectOrderA !== subjectOrderB) {
            return subjectOrderA - subjectOrderB;
        }

        const subjectA = a.Subject?.toLowerCase() || '';
        const subjectB = b.Subject?.toLowerCase() || '';
        if (subjectA < subjectB) return -1;
        if (subjectA > subjectB) return 1;

        const sectionOrderA = Number(a.SectionOrder) || 0;
        const sectionOrderB = Number(b.SectionOrder) || 0;
        if (sectionOrderA > 0 && sectionOrderB === 0) return -1;
        if (sectionOrderA === 0 && sectionOrderB > 0) return 1;
        if (sectionOrderA > 0 && sectionOrderB > 0 && sectionOrderA !== sectionOrderB) {
            return sectionOrderA - sectionOrderB;
        }

        const sectionA = a.Section?.toLowerCase() || '';
        const sectionB = b.Section?.toLowerCase() || '';
        if (sectionA < sectionB) return -1;
        if (sectionA > sectionB) return 1;

        const topicOrderA = Number(a.TopicOrder) || 0;
        const topicOrderB = Number(b.TopicOrder) || 0;
        if (topicOrderA > 0 && topicOrderB === 0) return -1;
        if (topicOrderA === 0 && topicOrderB > 0) return 1;
        if (topicOrderA > 0 && topicOrderB > 0 && topicOrderA !== topicOrderB) {
            return topicOrderA - topicOrderB;
        }

        const topicA = a.Topic?.toLowerCase() || '';
        const topicB = b.Topic?.toLowerCase() || '';
        if (topicA < topicB) return -1;
        if (topicA > topicB) return 1;

        return 0;
    });
};